var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/filter"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":3},React.createElement("g",{"id":"icon/filter","stroke":"#333333"},React.createElement("polygon",{"id":"Line","points":"20.6574067 4 13.6687856 12.7409659 13.6687856 19.1700001 11.4116672 19.1700001 11.4116672 12.7409659 4 4"})))]);
}

Filter.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Filter;

Filter.default = Filter;
